import styled from 'styled-components';
import type { MetricHintTone } from './types';

export const StatCard = styled.div`
    border: 1px solid var(--color-border, #e5e7eb);
    border-radius: 12px;
    padding: 14px 16px;
    background: var(--color-card, var(--design-card, #fff));
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-height: 96px;
    min-width: 0;
    overflow-wrap: anywhere;
`;

export const StatLabel = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    font-weight: 500;
    color: var(--color-muted-foreground, #6b7280);
`;

export const StatValue = styled.p`
    margin: 0;
    font-size: 24px;
    font-weight: 700;
    line-height: 1.1;
    color: var(--color-foreground, #111827);
    font-variant-numeric: tabular-nums;
`;

export const StatPlaceholder = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

const hintToneColor: Record<MetricHintTone, string> = {
    positive: 'var(--color-emerald-600, #059669)',
    negative: 'var(--color-red-600, #dc2626)',
    neutral: 'var(--color-muted-foreground, #6b7280)',
};

export const StatHint = styled.p<{ $tone: MetricHintTone }>`
    margin: 0;
    font-size: 12px;
    font-weight: 600;
    color: ${({ $tone }) => hintToneColor[$tone]};
`;
